import React from "react";
import DetailWrapper from "../../../components/detailWrapper";
import CloseDetailPage from "../../../components/CloseComponent/CloseDetailPage";
import { AiFillCheckCircle } from "react-icons/ai";
import { Button } from "semantic-ui-react";
import { useNavigate } from "react-router";
import { useTranslation } from "react-i18next";
import { RiCustomerService2Fill } from "react-icons/ri";
import ResultPage from "../../../components/ResultPage/ResultPage";
import { useDispatch } from "react-redux";
import { openChat } from "../../../redux/action/member/memberAction";

const AlreadyBind = () => {
  const { t } = useTranslation();
  const i18n = (key) => t(`formHint.${key}`);
  const i18n_common = (key) => t(`common.${key}`);

  const navigate = useNavigate();

  const dispatch = useDispatch();

  return (
    <ResultPage
      buttonProps={{
        content: i18n_common("contactCustomerServiceNow"),
        onClick: () => {
          dispatch(openChat());
        },
      }}
      resultContent={`${i18n("contactCustomerService")}`}
      resultText={i18n("youAlreadyBindCard")}
      pageType="service"
      pageTitle={i18n("alreadyBindCard")}
    />
  );
};

export default AlreadyBind;
